import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import DashboardSidebar from "@/components/dashboardSidebar/dashboardSidebar";
import DashboardSidebarMobile from "@/components/dashboardSidebarMobile/dashboardSidebarMobile";
import ModalTemporaryClosing from "@/components/modalTemporaryClosing/modalTemporaryClosing";

import { configService } from "@/settings/api-url";
@Component({
  components: {
    DashboardSidebar,
    DashboardSidebarMobile,
    ModalTemporaryClosing,
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      const { status } = vm.getSubscription;
      if (status === "pending") {
        next({ name: "subscriptionOnBoarding" });
      } else {
        next();
      }
    });
  },
})
export default class SubscriptionsDashboard extends Vue {
  @Action action_getMenus;

  @Getter getSubscription;
  @Getter getCity;
  @Getter getCurrentOrder;
  @Getter getDashboardSelectedTabIndex;
  @Getter getIsUnderMobile;

  @Mutation SPINNER;
  @Mutation DASHBOARD_SELECTED_TAB_INDEX;

  isShowingSidebar = false;
  isShowingTemporaryClosingModal = true;

  get getSelectedTabOrder() {
    if (this.getDashboardSelectedTabIndex === 0) return this.getCurrentOrder;
    if (this.getDashboardSelectedTabIndex === 1) return this.getSubscription;
  }

  get isShowingMobileNavBar() {
    const { name } = this.$route;
    if (name === "subscriptionLastOrderDetail" || name === "subscriptionNextOrderDetail") {
      return false;
    }
    return true;
  }

  async mounted() {
    this.SPINNER(true);
    await this.action_getMenus({ commerceId: this.getCity.id });
    this.SPINNER(false);
  }

  redirectToFoody() {
    window.open("https://app.foody.com.co/programar", "_blank");
  }

  logout() {
    delete configService.defaults.headers.common["Authorization"];
    localStorage.clear();
    this.$router.go(0);
  }
}
